<template>
  <div>
    <b-modal id="modalEditDocumentTemplates" ref="modalEditDocumentTemplates" :title="$t('Document templates')" hide-footer >
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" v-if="editItem.template_id !== 0" :label="$t('Name in server')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input v-model="editItem.path" disabled/>
          </b-form-group>
        <b-form-group label-align="right" :label="$t('File')" enctype="multipart/form-data" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group-append>
            <b-form-file ref="formFile" :placeholder="$t('Choose a file...')" accept=".odt" v-model="file">
            </b-form-file>
            <b-button size="sm" variant="secondary" @click="downloadFile">{{ $t('Download') }}</b-button>
          </b-input-group-append>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.template_id !== 0" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="optionsType" v-model="editItem.type"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditDocumentTemplates.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import download from 'downloadjs'
import axiosInstance from '@/utils/api.js'
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      file: null,
      optionsType: [
        {value: 1, text: this.$i18n.t('Bill')},
        {value: 2, text: this.$i18n.t('TAX invoice')},
        {value: 3, text: this.$i18n.t('User info sheet')},
        {value: 4, text: this.$i18n.t('Certificate of completion')},
        {value: 5, text: this.$i18n.t('Receipt')},
        {value: 6, text: this.$i18n.t('Contract')},
        {value: 7, text: this.$i18n.t('Bill details')}
      ]
    }
  },
  methods: {
    async save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.file) {
        var reader = new FileReader()
        reader.onload = (event) => {
          var contents = event.target.result
          this.editItem.contents = contents
          let response = this.editItem.template_id !== 0
            ? this.$store.dispatch('Settings/UPDATE_DOCUMENT_TEMPLATES', this.editItem)
            : this.$store.dispatch('Settings/CREATE_DOCUMENT_TEMPLATES', this.editItem)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_DOCUMENT_TEMPLATES')
              this.$refs.modalEditDocumentTemplates.hide()
              this.$root.$emit('makeToasts')
            }
          })
        }
        reader.onerror = function (event) {
          console.error('Файл не может быть прочитан! код ' + event.target.error.code)
        }
        reader.readAsArrayBuffer(this.file)
      } else {
        let response = await this.$store.dispatch('Settings/DOWNLOAD_FILE_DOCUMENT_TEMPLATES', this.editItem.template_id)
        let payload = this.editItem
        response = axiosInstance.put('/settings/documents/templates?name=' + payload.name + '&type=' + payload.type + '&template_id=' + payload.template_id, response.data)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            setTimeout(this.$store.dispatch, 500, 'Settings/GET_DOCUMENT_TEMPLATES')
            this.$refs.modalEditDocumentTemplates.hide()
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    downloadFile () {
      this.$store.dispatch('Settings/DOWNLOAD_FILE_DOCUMENT_TEMPLATES', this.editItem.template_id).then(response => {
        download(response.data, this.editItem.path, 'application/pdf')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/documents/documentTemplates/editModal.vue